import { useLanguage } from "../i18n/LanguageContext";
import dongMaPhoto from "../assets/images/dong-ma.jpg";
import yangYingPhoto from "../assets/images/yang-ying.jpg";
import "./TeacherSection.css";

function TeacherCard({ data, photo, reverse }) {
  const altText = `${data.name} - ${data.title} - ${data.instrument}`;

  return (
    <article className={`teacher-card ${reverse ? "teacher-card-reverse" : ""}`}>
      <div className="teacher-photo-wrapper">
        {photo ? (
          <img src={photo} alt={altText} className="teacher-photo" loading="lazy" />
        ) : (
          <div className="teacher-photo-placeholder">
            <span className="placeholder-text">{data.name.charAt(0)}</span>
          </div>
        )}
      </div>
      <div className="teacher-info">
        <h3 className="teacher-name">{data.name}</h3>
        <p className="teacher-title">{data.title}</p>
        <p className="teacher-instrument">{data.instrument}</p>
        <div className="teacher-divider" aria-hidden="true" />
        <div className="teacher-bio">
          {data.bio.map((paragraph, i) => (
            <p key={i}>{paragraph}</p>
          ))}
        </div>
        <ul className="teacher-highlights" aria-label="Credentials">
          {data.highlights.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>
    </article>
  );
}

export default function TeacherSection() {
  const { t } = useLanguage();

  return (
    <section id="teachers" className="teachers-section" aria-label="Teachers">
      <div className="section-header">
        <h2 className="section-title">{t.teachers.sectionTitle}</h2>
        <div className="section-divider" aria-hidden="true">
          <span className="divider-dot" />
          <span className="divider-line" />
          <span className="divider-dot" />
        </div>
        <p className="teachers-subtitle">{t.teachers.sectionSubtitle}</p>
      </div>
      <div className="teachers-container">
        <TeacherCard data={t.teachers.dongMa} photo={dongMaPhoto} reverse={false} />
        <TeacherCard data={t.teachers.yangYing} photo={yangYingPhoto} reverse={true} />
      </div>
    </section>
  );
}
